import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserResponses = _resolveComponent("UserResponses")!
  const _component_Questionnaire = _resolveComponent("Questionnaire")!
  const _component_QuestionnaireCover = _resolveComponent("QuestionnaireCover")!

  return (_ctx.$route.name === 'user_responses')
    ? (_openBlock(), _createBlock(_component_UserResponses, {
        key: 0,
        "questionnaire-id": parseInt(_ctx.$route.params.questionnaireId)
      }, null, 8, ["questionnaire-id"]))
    : (_ctx.$route.params.questionnaire_id)
      ? (_openBlock(), _createBlock(_component_Questionnaire, {
          key: 1,
          "questionnaire-id": parseInt(_ctx.$route.params.questionnaire_id)
        }, null, 8, ["questionnaire-id"]))
      : (_openBlock(), _createBlock(_component_QuestionnaireCover, { key: 2 }))
}